// Vue
import Vue from 'vue'

export const registerComponents = (components: { [component: string]: any }) => {
    Object.keys(components).forEach(name => {

        const prefix = APP_PREFIX.toLowerCase()

        const camelCasePrefix = prefix.charAt(0).toUpperCase() + prefix.slice(1)

        Vue.component(`${camelCasePrefix}${name}`, components[name])
    })
}